import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ybxzpxynt: FaireProductEntity = {
  token: "p_8ybxzpxynt",
  type: "product",
  name: "Coop's Peanut Butter Sauce",
  brandToken: "b_27yaz87n28",
  brandName: "Coop's",
  imageUrl:
    "https://cdn.faire.com/fastly/1c31dfbbab574e8f04beb6db617a6b2990c7341ee468207c68af73439595f507.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b165fbb671264ee241d520dd9f3fe7dd28861bb7797da4391edaefab202cd04b.jpeg",
    "https://cdn.faire.com/fastly/5a2358fe09285cd624e377425eb82c14a97ca9342645754e1ad321f3deb67043.jpeg",
    "https://cdn.faire.com/fastly/4a6c39967a5ac98d0ff57018bf8878e91fc5ce7cdf96886f7cdc03a4b7aa1aec.png",
  ],
  priceDollars: 7.6,
  description:
    "Peanut butter lovers—the wait is over! Meet Coop’s Peanut Butter Sauce, handmade simply in small batches from pure unadulterated peanuts and sugar. Warm and undeniably nutty with just a hint of sweetness, it’s smooth as ever with a thick, spoonable texture that drizzles and drips with ease. \n\nIndulge in this luscious sauce right out of the jar or heat it up for even more depth. Atop ice cream, we consider it liquid gold, but don’t stop there—spread it on brownies, drip it over apple slices, plunge your pretzels into it or devour it straight by the spoonful. We don’t judge!\n\nCraving a double dose? Pair it with our rich, dark Coop’s Original Hot Fudge. The combinations are endless.\n",
  tags: [],
  msrpDollars: 13.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:30.074Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
